import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CalendarInput from "../../Common/FormElements/CalendarInput/CalendarInput";
import { getDelivery, updateDelivery } from "../../../REDUX/actions/delivery";
import CheckBox from "../../Common/FormElements/CheckBox/CheckBox";
import Button from "../../Common/FormElements/Button/Button";
import TextArea from "../../Common/FormElements/TextArea/TextArea";
import Select from "../../Common/FormElements/Select/Select";
import { statusOptions } from "../useDeparture";
import DeliveryActions from "../DeliveryActions";
import {
  closeCenteredModal,
  openCenteredModal,
} from "../../../REDUX/actions/centeredModal";
import ValidateDelivery from "../ValidateDelivery";
import { toast } from "react-toastify";

const DepartureDelivery = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { delivery } = useSelector((state) => state.deliveryReducer);
  const { user } = useSelector((state) => state.userReducer);
  const transporter = delivery?.attributes?.transporter?.data;
  const [formData, setFormData] = useState({});

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      recupDate: moment(delivery?.attributes?.recupDate).utc(true).toDate(),
      validated: delivery?.attributes?.validated,
      comment: delivery?.attributes?.deliveryComment,
    }));
  }, [delivery]);

  return (
    <div className="d-flex flex-column text-dark position-relative text-break">
      <div className="row g3">
        <div className="col-4 d-flex flex-column">
          <p className="mb-2">{t("Delivery Date Validation")}</p>
          {moment(delivery?.attributes?.date).isValid() && (
            <div className="d-flex align-items-center gap-2">
              <p className="mb-0 sBold f14">
                {moment(delivery?.attributes?.date).format("DD/MM/YYYY")}
              </p>
              <CheckBox
                checked={formData.validated}
                disabled={
                  formData.validated ||
                  ![1, 4]?.includes(user?.attributes?.userRole)
                }
                callback={(e) => {
                  if (
                    !formData.validated &&
                    [1, 4]?.includes(user?.attributes?.userRole)
                  ) {
                    dispatch(
                      openCenteredModal(
                        <ValidateDelivery
                          handleClick={() => {
                            dispatch(
                              updateDelivery(
                                delivery?.id,
                                { validated: true },
                                () => {
                                  dispatch(closeCenteredModal());
                                  toast.success(
                                    t("Delivery date has been validated")
                                  );
                                }
                              )
                            );
                            setFormData((prev) => ({
                              ...prev,
                              validated: true,
                            }));
                          }}
                        />
                      )
                    );
                  }
                }}
              />
            </div>
          )}
        </div>
        <div className="col-4">
          <p className="mb-2">{t("Transport Company")}</p>
          {transporter ? (
            <div className="border border-1 py-2 px-3 br4">
              <p className="mb-0">{transporter?.attributes?.companyName}</p>
              {transporter?.attributes?.companyPhoneNumber && (
                <p className="mb-0">
                  T : {transporter?.attributes?.companyPhoneNumber}
                </p>
              )}
              {transporter?.attributes?.companyEmail && (
                <p className="mb-0">
                  M : {transporter?.attributes?.companyEmail}
                </p>
              )}
            </div>
          ) : (
            "-"
          )}
        </div>
        <div className="col-4">
          <p className="mb-2">{t("Transport Referent")}</p>
          {transporter ? (
            <div className="border border-1 py-2 px-3 br4">
              <p className="mb-0">{transporter?.attributes?.name}</p>
              {transporter?.attributes?.phoneNumber && (
                <p className="mb-0">
                  T : {transporter?.attributes?.phoneNumber}
                </p>
              )}
              {transporter?.attributes?.user?.data?.attributes?.email && (
                <p className="mb-0">
                  M : {transporter?.attributes?.user?.data?.attributes?.email}
                </p>
              )}
            </div>
          ) : (
            "-"
          )}
        </div>
        <div className="mt-3">
          <p>{t("Add the pickup date to the depot")}</p>
          <CalendarInput
            placeholder={t("Retrieval Date")}
            disabled={![1, 4]?.includes(user?.attributes?.userRole)}
            value={
              formData?.recupDate
                ? moment(formData.recupDate).utc(true).toDate()
                : null
            }
            callback={(e) => {
              setFormData((prev) => ({
                ...prev,
                recupDate: e.value ? moment(e.value).utc(true) : null,
              }));
              dispatch(
                updateDelivery(
                  delivery?.id,
                  {
                    recupDate: e.value ? moment(e.value).utc(true) : null,
                  },
                  () => toast.success(t("Pickup date has been updated"))
                )
              );
            }}
            minDate={false}
          />
        </div>
      </div>
      <hr className="my-4" />
      <DeliveryActions />

      {[0, 2, 3]?.includes(user?.attributes?.userRole) ? (
        formData?.comment?.length > 0 && (
          <div className="d-flex flex-column gap-2 mb-4">
            <p className="f16 mb-0 sBold">{t("Transporter comment")}</p>
            <p className="mb-0 p-2 br5 bg-white border-1 border-lightGrey">
              {formData.comment ?? ""}
            </p>
          </div>
        )
      ) : (
        <div className="d-flex flex-column gap-3">
          <TextArea
            placeholder={t("Comment")}
            value={formData.comment}
            callback={(e) =>
              setFormData((prev) => ({
                ...prev,
                comment: e.target.value,
              }))
            }
          />
          <div className="ms-auto">
            <Button
              onClick={() => {
                dispatch(
                  updateDelivery(
                    delivery?.id,
                    { deliveryComment: formData.comment },
                    () =>
                      dispatch(
                        getDelivery(delivery?.id, t("Comment has been updated"))
                      )
                  )
                );
              }}
            >
              {t("Save")}
            </Button>
          </div>
        </div>
      )}
      <div className="d-flex flex-column w-100 max-w-200px">
        <p className="mb-2">{t("Delivery Status")}</p>
        <Select
          name="deliveryStatus"
          disabled={
            ![1, 4]?.includes(user?.attributes?.userRole) ||
            !["READY"]?.includes(delivery?.attributes?.status)
          }
          value={statusOptions(t).find(
            (option) => option.code === delivery?.attributes?.deliveryStatus
          )}
          placeholder={
            statusOptions(t).find(
              (option) => option.code === delivery?.attributes?.deliveryStatus
            )?.name
          }
          options={statusOptions(t).filter((option) =>
            ["RECUP", "DELIVERY", "INCIDENT"].includes(option.code)
          )}
          callback={(e) =>
            dispatch(
              updateDelivery(
                delivery?.id,
                { deliveryStatus: e.value.code },
                () =>
                  dispatch(
                    getDelivery(delivery?.id, t("Status has been changed"))
                  )
              )
            )
          }
        />
      </div>
    </div>
  );
};

export default DepartureDelivery;
